import { createAtomObserver } from '@exodus/atoms'

const createAbTestingPlugin = ({ abTesting, featureFlagAtoms, abTestingAtom, port }) => {
  const observer = createAtomObserver({ port, atom: abTestingAtom, event: 'abTesting' })
  observer.register()

  const onStart = async () => {
    featureFlagAtoms.abTesting?.get().then(({ isOn }) => {
      if (!isOn) return
      abTesting.load()
    })
  }

  const onLoad = async () => {
    observer.start()
  }

  const onClear = async () => {
    await abTesting.clear()
  }

  const onStop = () => {
    observer.unregister()
  }

  return { onStart, onLoad, onClear, onStop }
}

const abTestingPluginDefinition = {
  id: 'abTestingPlugin',
  type: 'plugin',
  factory: createAbTestingPlugin,
  dependencies: ['abTesting', 'featureFlagAtoms', 'abTestingAtom', 'port'],
  public: true,
}

export default abTestingPluginDefinition
